import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Stack, Typography } from "@mui/material";
import {
  FormUnderwritingHomeOptions,
  getUnderwritingQuestions,
  UnderwritingQuestionsForm,
} from "@covertree/new-business-forms";
import { Button } from "@covertree/ui";
import { useUwContext } from "./useUwContext";
import { OnContinue, UwContext } from "./types";

interface HomeOptionsPropsNotInD2C {
  isD2C: false;
  context: UwContext;
  title?: string;
}

interface HomeOptionsPropsInD2C {
  isD2C: true;
  onContinue: OnContinue;
}

type HomeOptionsProps = HomeOptionsPropsInD2C | HomeOptionsPropsNotInD2C;

function HomeOptions(props: HomeOptionsProps) {
  const form = useFormContext<UnderwritingQuestionsForm>();

  const { state, questions, setModalCondition } = props.isD2C
    ? useUwContext()
    : (props as HomeOptionsPropsNotInD2C).context;
  const { title } = props as Partial<HomeOptionsPropsNotInD2C>;

  const questionsOptions = useMemo(
    () => getUnderwritingQuestions(form, questions, "option", state),
    [form, form.formState.isValid, questions, state]
  );

  return (
    <Stack spacing={4}>
      {props.isD2C && (
        <Typography variant="h6" sx={{ py: 1 }}>
          Take some time and check all that apply.
        </Typography>
      )}
      <FormUnderwritingHomeOptions
        title={
          !props.isD2C
            ? title ?? "Does this look right for the applicant's property?"
            : undefined
        }
        questions={questionsOptions}
        setModalCondition={setModalCondition}
      />
      {props.isD2C && <Button onClick={props.onContinue}>Next</Button>}
    </Stack>
  );
}

export { HomeOptions };
